export default __webpack_public_path__ + "static/media/discussions.b5f36a51.svg";